// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__NKcUs","box":"modal_box__ZRFsD"};